import axios from "axios";
import $ from 'jquery';
import { isChrome as chrome,isMobile as mobileTab,isMobileOnly as omobile,isTablet as tablete,isBrowser as browser,isSmartTV as smarttv,isWearable as wearable,isAndroid as android,isWinPhone as winphone,isIOS as ios,isFirefox as ff,isSafari as safari,isOpera as opera,isIE as ie,isEdge as edge,isYandex as yandex,isChromium as chromium,isMobileSafari as mobsafari,osVersion as version,osName as osname,fullBrowserVersion as fbrowserversion,browserVersion as browserVer,browserName as browserName,mobileVendor as mobvendor,mobileModel as mobmodel,engineName as engName,engineVersion as engversion,getUA as getua,deviceType as deviceType,isIOS13 as ios13,isIPhone13 as iphone13,isIPad13 as ipad13,isIPod13 as ipod13,isElectron as isElectron,deviceDetect as devicedetect} from "react-device-detect";
const productFetchAttributesList = function(e)
{ 
	let attributes = [];
    let productList = this.state.addProduct;  
    let  interestId=2;
    
    console.log('-----asdfghjkl----------',interestId);  

      axios      
      
      .get(process.env.REACT_APP_NAME+"/api/v1/session/"+interestId+"/attributeList")          
      .then(res => {
        console.log('---------interestIdproduct--------------',res.data.responseData);

          let eqarray=res.data.responseData;        
     
          let attributes = [];
          let productList= this.state.addProduct;
          for(let i =0;i<eqarray.length;i++){
           let n = {attrKey:eqarray[i].attrLabel,attrValue:'',status:false,id:i};
           attributes.push(n);
            }
          
          let n = {name : 'ChannelCreation',
              attributes
            }
            productList.push(n);       
          this.setState({
          addProduct:productList
          },()=>console.log('-------------------------------------------addProduct',this.state.addProduct))
      })
      .catch(err =>{
          console.log('-------Product List---there is problem------------');

      });
}

export { productFetchAttributesList };